import React, { useState } from 'react';
import './SearchComponent.css';
import { trackSearch } from '../../services/analyticsService';

interface SearchComponentProps {
  onSearchChange: (query: string) => void;
}

const SearchComponent: React.FC<SearchComponentProps> = ({ onSearchChange }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };

  // Search has no submit button; Enter is treated as the "submit" action.
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && searchValue.trim()) {
      console.log('[GA4 Debug] Search submitted:', searchValue);
      trackSearch(searchValue.trim());
    }
  };

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <input 
          type="text" 
          className="search-input" 
          placeholder="Search ..."
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <svg className="search-icon" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle 
            cx="7" 
            cy="7" 
            r="6" 
            stroke="#B8BCC0" 
            strokeWidth="2"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            fill="none"
          />
          <path 
            d="M12 12l5 5" 
            stroke="#B8BCC0" 
            strokeWidth="2"
            strokeLinecap="butt"
            strokeLinejoin="miter"
          />
        </svg>
      </div>
    </div>
  );
};

export default SearchComponent;